export const WEEK = 'week';
export const DAY = 'day';
export const MONTH = 'month';
